<template>
  <IconRoundText>
    <CapSVG slot="icon" />
    Cursos concluídos <strong>{{ user.courses_completed }}</strong> / {{ user.courses_attended }}
  </IconRoundText>
</template>

<script>
import IconRoundText from '@/components/text/IconRoundText'
import CapSVG from '@/components/svg/CapSVG'

export default {
  components: {
    IconRoundText,
    CapSVG,
  },

  props: {
    user: { type: Object, required: true }
  }
}
</script>